import { AxiosResponse } from 'axios';
import {
	AuxDataKeySetResponse,
	AuxDataResponse,
	AuxDataSetCreateRequest,
} from '../types/auxData';
import { getApiUrl } from '../util/util';
import { deleteRequest, get, put } from './http';

interface AuxDataApi {
	createAuxData(
		authorizationToken: string,
		params: AuxDataSetCreateRequest,
		entityLocator: string,
	): Promise<AxiosResponse<AuxDataResponse>>;
	getAuxData(
		authorizationToken: string,
		entityLocator: string,
		key: string,
	): Promise<AxiosResponse<AuxDataResponse>>;
	getAuxDataKeys(
		authorizationToken: string,
		entityLocator: string,
		pageNum: number,
	): Promise<AxiosResponse<AuxDataKeySetResponse>>;
	deleteAuxData(
		authorizationToken: string,
		entityLocator: string,
		key: string,
	): Promise<AxiosResponse<AuxDataResponse>>;
}

export default {
	createAuxData(
		authorizationToken: string,
		params: AuxDataSetCreateRequest,
		entityLocator: string,
	) {
		return put(
			encodeURI(`${getApiUrl()}/auxData/${entityLocator}`),
			authorizationToken,
			params,
		);
	},
	getAuxData(authorizationToken: string, entityLocator: string, key: string) {
		return get(
			encodeURI(`${getApiUrl()}/auxData/${entityLocator}/${key}`),
			authorizationToken,
		);
	},
	getAuxDataKeys(
		authorizationToken: string,
		entityLocator: string,
		pageNum: number,
	) {
		// page size is fixed to 100 keys
		return get(
			encodeURI(`${getApiUrl()}/auxData/${entityLocator}?page=${pageNum}`),
			authorizationToken,
		);
	},
	deleteAuxData(
		authorizationToken: string,
		entityLocator: string,
		key: string,
	) {
		return deleteRequest(
			encodeURI(`${getApiUrl()}/auxData/${entityLocator}/${key}`),
			authorizationToken,
		);
	},
} as AuxDataApi;
